import React from 'react';
import { Text } from '@feast-it/pesto';
import PropTypes from 'prop-types';

import * as Styled from './styles';

const JoinToolTip = ({ message }) => {
  return (
    <Styled.Container>
      <Text
        textAlign="center"
        fontFamily="body"
        fontSize="body"
        lineHeight="body"
      >
        {message}
      </Text>
      <Styled.Arrow />
    </Styled.Container>
  );
};

JoinToolTip.propTypes = {
  message: PropTypes.string.isRequired,
};

export default JoinToolTip;
